// companyDetails.tsx
// import { Button } from "@/components/ui/button";
// import ProfileDetailsForm from "./dialogCompanyDetails/dialog-compnayDetails"
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CompanyProfileMockData } from "./mockData/mockCompanyProfile";
import { Phone, Mail, Globe } from "lucide-react";
import userIcon from "@/assets/myaccount/user.svg";
import facebook from "@/assets/myaccount/facebook.svg";
import instagram from "@/assets/myaccount/insta.svg";
import xIcon from "@/assets/myaccount/x.svg";
import youtube from "@/assets/myaccount/youtube.svg";
import linkedIn from "@/assets/myaccount/linkedin.svg";
import locationIcon from "@/assets/myaccount/location.svg";
import briefcaseIcon from "@/assets/myaccount/briefcase.svg";
import { Pencil } from "lucide-react";
import upArrowIcon from "@/assets/icons/arrow-up-green.svg";
import downArrowIcon from "@/assets/icons/arrow-down-green.svg";
import logoImage from "@/assets/myaccount/logo.svg";
// import Image from "next/image";

interface CompanyProfileProps {
  isCompanyDetailHidden: boolean;
  setIsCompanyDetailHidden: (hidden: boolean) => void;
}

const CompanyProfile: React.FC<CompanyProfileProps> = ({
  isCompanyDetailHidden,
  setIsCompanyDetailHidden,
}) => {
  const navigate = useNavigate();
  //   navigate(`/admin/dashboard/users/${userId}`);
  // const [isOpen, setIsOpen] = useState(false);
  const [showScreen, setShowScreen] = useState(true);
  const [hasData, setHasData] = useState(true);
  // const [isLoading, setIsLoading] = useState(true);
  const [image, setImage] = useState<string | null>(null);

  const routeToDetails = useCallback(() => {
    console.log("line 13");
    // event.preventDefault(); // Optional: Prevents default behavior
    navigate(`/profile/company-profile/edit`);
  }, []);

  useEffect(() => {
    const loadProfile = () => {
      // Simulate fetching profile data
      console.log(CompanyProfileMockData, "line 30");
      if (!CompanyProfileMockData) {
        console.log("line 32");
        // console.log
        setHasData(false);
        setShowScreen(false); // Hide this screen if data exists
        navigate("/profile/company-profile/edit"); // Optional: auto-redirect
      }
    };

    loadProfile();
  }, [navigate]);

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    console.log("line 9");
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(reader.result as string); // Set the uploaded image as the source
      };
      reader.readAsDataURL(file);
    }
  };

  if (!showScreen) return null;

  if (!hasData) {
    // Show EMPTY screen if no data
    console.log(hasData, "line 46");
    return (
      <div className="h-[50%] bg-[#f6f8fa] flex items-center justify-center">
        <div className="text-center max-w-xl px-4">
          <h2 className="text-2xl font-semibold text-green-600 mb-4">
            Showcase Your Company Profile
          </h2>
          <p className="text-gray-700 text-base leading-relaxed mb-6">
            Add Your Logo, Service Areas, And Main Contact To Complete Your
            BuildMapper Presence. A Complete Profile Helps Builders Trust And
            Connect With You Faster.
          </p>
          <button
            onClick={() => navigate(`/profile/company-profile/edit`)}
            className="bg-green-600 text-white font-semibold px-6 py-2 rounded-md hover:bg-green-700 transition"
          >
            Add Company Info
          </button>
        </div>
      </div>
    );
  } else {
    return (
      // <div className="max-w-6xl mx-auto p-6 bg-white border border-gray-200 rounded-lg shadow-sm">
      <div className="h-[50%] w-full p-5 bg-[#f6f8fa] items-center relative">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-">
          <div className="space-y-2">
            <div className="flex items-start space-x-4">
              <div className="relative w-20 h-20">
                <div className="w-full h-full rounded-full flex items-center justify-center">
                  <img
                    src={image || logoImage}
                    alt="Company Logo"
                    className="w-[84px] h-[84px] rounded-full object-cover border-2 border-solid border-gray-300"
                  />
                </div>

                <div className="absolute h-7 w-7 bottom-0 right-0 rounded-full bg-green-500 flex items-center justify-center cursor-pointer">
                  <input
                    type="file"
                    accept="image/png, image/jpeg, image/jpg, image/gif, image/webp"
                    onChange={handleImageChange}
                    className="absolute inset-0 opacity-0 cursor-pointer"
                  />
                  <Pencil className="h-3.5 w-3.5 text-white" />
                </div>
              </div>

              <div className="flex flex-col justify-center">
                <h1 className="text-xl font-bold">Ingoude Construction</h1>
                <div className="flex items-center text-gray-600 mt-1">
                  <img
                    src={userIcon}
                    alt="User Icon"
                    className="w-[18px] h-[18px] object-contain my-[1px] flex-shrink-0"
                  />
                  <span className="w-[81px] h-[20px] ml-[3px] font-outfit text-[14px] font-medium leading-[1.43] text-[#828282]">
                    Steve Rogers
                  </span>
                </div>
                <div className="flex pt-2">
                  <a href="#" className="py-1 pr-1 bg-gray-100 rounded-full">
                    <img
                      src={facebook} // Replace this with your actual icon path or import
                      alt="Facebook"
                      className="w-[18px] h-[18px]"
                    />
                  </a>

                  <a href="#" className="p-1 bg-gray-100 rounded-full">
                    <img
                      src={instagram} // Replace this with your actual icon path or import
                      alt="Facebook"
                      className="w-[18px] h-[18px]"
                    />
                  </a>
                  <a href="#" className="p-1 bg-gray-100 rounded-full">
                    <img
                      src={youtube} // Replace this with your actual icon path or import
                      alt="Facebook"
                      className="w-[18px] h-[18px]"
                    />
                  </a>
                  <a href="#" className="p-1 bg-gray-100 rounded-full">
                    <img
                      src={linkedIn} // Replace this with your actual icon path or import
                      alt="Facebook"
                      className="w-[18px] h-[18px]"
                    />
                  </a>
                  <a href="#" className="p-1 bg-gray-100 rounded-full">
                    <img
                      src={xIcon} // Replace this with your actual icon path or import
                      alt="Facebook"
                      className="w-[18px] h-[18px]"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="space-y-3">
            <p className="text-[#181818] text-[14px] font-normal leading-[1.57] font-[Outfit] w-[286px] h-[66px]">
              Ingoude Construction provides the best in the flooring services.
              Focused on customer service and high quality work.
            </p>
          </div>
          <div className="space-y-12">
            <div className="space-y-1">
              <div className="flex items-center">
                <Phone className="w-[18px] h-[18px] my-[2px] object-contain text-green-600" />

                <span className="w-[199px] h-[22px] ml-[8px] font-outfit text-[14px] font-medium leading-[1.57] text-[#181818]">
                  (201) 324 6723
                </span>
              </div>
              <div className="flex items-center">
                <Mail className="w-[18px] h-[18px] my-[2px] object-contain text-green-600" />
                <span className="w-[199px] h-[22px] ml-[8px] font-outfit text-[14px] font-medium leading-[1.57] text-[#181818]">
                  ingoudeinfo@gmail.com
                </span>
              </div>
              <div className="flex items-center">
                <Globe className="w-[18px] h-[18px] my-[2px] object-contain text-green-600" />
                <span className="w-[199px] h-[22px] ml-[8px] font-outfit text-[14px] font-medium leading-[1.57] text-[#181818]">
                  www.ingoudeconstructions.com
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          className={
            isCompanyDetailHidden
              ? "hidden"
              : "grid grid-cols-1 md:grid-cols-3 mt-5"
          }
        >
          <div className="space-y-3">
            <div className="space-y-4">
              <div className="flex items-center">
                <img
                  src={locationIcon}
                  alt="Location Icon"
                  className="w-[24px] h-[24px] mr-1 object-contain"
                />
                <h2 className="w-[109px] h-[20px] flex-grow-0 font-[Outfit] text-[18px] font-medium leading-[1.11] text-[#181818] text-left">
                  Service Areas
                </h2>
              </div>

              <div className="flex flex-wrap gap-2">
                {[
                  "North Vancouver",
                  "South Vancouver",
                  "Toronto",
                  "Brampton",
                  "Oakville",
                ].map((city) => (
                  <span
                    key={city}
                    className="font-[Outfit] text-[14px] font-medium leading-[1.4] text-[#828282] bg-[#efefef] rounded-md px-3 py-1"
                  >
                    {city}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="space-y-3">
            <div className="space-y-4">
              <div className="flex items-center">
                <img
                  src={briefcaseIcon}
                  alt="Briefcase Icon"
                  className="w-[24px] h-[24px] flex-grow-0 object-contain mr-2"
                />
                <h2 className="w-[91px] h-[16px] flex-grow-0 font-[Outfit] text-[18px] font-medium leading-[1.11] text-left text-[#181818]">
                  Specialities
                </h2>
              </div>

              <div className="flex flex-wrap gap-2">
                {[
                  "Plumbing",
                  "Electrical Services",
                  "Roofing",
                  "Painting Services",
                ].map((city) => (
                  <span
                    key={city}
                    className="font-[Outfit] text-[14px] font-medium leading-[1.4] text-[#828282] bg-[#efefef] rounded-md px-3 py-1"
                  >
                    {city}
                  </span>
                ))}
              </div>
            </div>
          </div>

          <div className="">
            <div className="flex flex-col sm:flex-row gap-3 mt-[36px]">
              <button
                className="w-[136px] h-[40px] flex flex-row justify-center items-center gap-[8.3px] px-[26.5px] py-[13.2px] rounded-[6.6px] border-[0.8px] border-[#28af4a] bg-white text-[#28af4a]"
                onClick={routeToDetails}
              >
                <span className="h-[18px] text-center font-[Outfit] text-[14px] font-semibold text-[#28af4a]">
                  Edit Profile
                </span>
              </button>

              <button
                className="w-[136px] h-[40px] flex flex-row justify-center items-center gap-[6px] px-[16px] py-[10px] rounded-[6.6px] border-[0.8px] border-[#28af4a] bg-white text-[#28af4a]"
                onClick={() => {
                  // navigate("/company-profile/sharable");
                  window.open("/company-profile/sharable")
                }}
              >
                <span className="h-[18px] text-center font-[Outfit] text-[14px] font-semibold text-[#28af4a]">
                  Share Profile
                </span>
              </button>
            </div>
          </div>
        </div>
        <div
          onClick={() => setIsCompanyDetailHidden(!isCompanyDetailHidden)}
          className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 z-20"
        >
          {isCompanyDetailHidden ? (
            <img src={downArrowIcon} alt="down arrow icon" />
          ) : (
            <img src={upArrowIcon} alt="up arrow icon" />
          )}
        </div>
      </div>
    );
  }
};

export default CompanyProfile;
